import { Link } from 'react-router-dom';
import { srcSet } from '../api';
import { formatCzk, formatPriceRange } from '../money';
import { useFavorites } from '../favorites';
import { usePageMeta } from '../seo';

/**
 * Oblíbené produkty.
 *
 * Dlaždice jsou záměrně jednodušší než v katalogu – žádné tlačítko do košíku.
 * Oblíbené jsou seznam k prohlédnutí; nákup i aktuální cena a sklad patří
 * na detail, kam každá dlaždice vede. Uložené ceny jsou orientační.
 */
export function FavoritesPage() {
  const { items, remove } = useFavorites();

  usePageMeta({
    title: 'Oblíbené | Super Krmivo',
    description: 'Produkty, které jste si uložili na později.',
    // Seznam je pro každého jiný a jen v prohlížeči – vyhledávač tu nemá co.
    index: false,
  });

  return (
    <>
      <h1>Oblíbené</h1>

      {items.length === 0 ? (
        <p className="empty muted">
          Zatím tu nic není. Srdíčkem na dlaždici si uložíte, k čemu se chcete vrátit.
          <br />
          <Link className="link" to="/">
            Zpět do obchodu
          </Link>
        </p>
      ) : (
        <div className="grid">
          {items.map((item) => (
            <div key={item.id} className="card product-card favorite-card">
              <button
                type="button"
                className="fav-remove"
                aria-label={`Odebrat ${item.name} z oblíbených`}
                onClick={() => remove(item.id)}
              >
                ✕
              </button>

              <Link to={`/produkt/${item.slug}`} className="favorite-link">
                <div className="thumb" aria-hidden="true">
                  {item.imageUrl === null ? (
                    <span className="thumb-placeholder">{item.name.slice(0, 1)}</span>
                  ) : (
                    <img
                      src={item.imageUrl}
                      srcSet={srcSet(item.imageThumbnails)}
                      sizes="(max-width: 640px) 45vw, 260px"
                      alt=""
                      loading="lazy"
                      decoding="async"
                    />
                  )}
                </div>
                <div className="product-body">
                  {item.brand !== null && <span className="brand-line">{item.brand}</span>}
                  <strong className="product-name">{item.name}</strong>
                  <div className="price-block">
                    {item.compareAtPriceFromMinor !== null && (
                      <s className="price-was">{formatCzk(item.compareAtPriceFromMinor)}</s>
                    )}
                    <span className="price">
                      {formatPriceRange(item.priceFromMinor, item.priceToMinor)}
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
